export const formatNumber = (num, { minDecimal = undefined, maxDecimal = undefined } = {}) => {
  return parseFloat(num).toLocaleString('en-GB', {
    minimumFractionDigits: minDecimal,
    maximumFractionDigits: maxDecimal,
  })
}
